import { ArrowBack, ArrowForward, FilterList, Search } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Grid,
  InputLabel,
  Snackbar,
  styled,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import httpclient from "../../utils";
import { useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
import MuiAlert from "@mui/material/Alert";

const MainBox = styled(Box)(({ theme }) => ({
  padding: "40px",
  borderRadius: "15px",
  display: "inline-block",
  border: "1px solid #888",
  margin: "20px",
  // textAlign: "center",
  height: "450px",
  [theme.breakpoints.down("md")]: {
    margin: "0",
    width: "300px",
    // marginBottom:"20px"
  },
  "& svg": {
  },
}));

const MainFlex = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& h2": {
    textAlign: "center",
    marginBottom: "40px"
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "10px",
  },
}));

const FilterBox = styled(Box)(({ theme }) => ({
  display: "flex",
  "& .MuiAutocomplete-inputRoot": {
    borderRadius: "4px 0px 0px 4px !important",
    padding: "6px 10px !important",
  },
  "& button": {
    borderRadius: "0px 4px 4px 0px !important",
    padding: "6px 10px !important",
  },
}));

// const rows = [
//   {
//     id: "343s",
//     name: "Harry Migure",
//     email: "harry@gmail.com",
//     cart: "4",
//     mobile: "912308122",
//   },
//   {
//     id: "343s",
//     name: "Harry Migure",
//     email: "harry@gmail.com",
//     cart: "4",
//     mobile: "912308122",
//   },
//   {
//     id: "234",
//     name: "Shawn Mendes",
//     email: "shawn@gmail.com",
//     cart: "2",
//     mobile: "13123123",
//   },
//   {
//     id: "21",
//     name: "Will Smith",
//     email: "will@gmail.com",
//     cart: "3",
//     mobile: "12431212332",
//   },
//   {
//     id: "15",
//     name: "Sara Whilmer",
//     email: "sara@gmail.com",
//     cart: "2",
//     mobile: "23213321",
//   },
// ];

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ExistingCustomer = ({ step,
  setStep,
  customerDetails,
  setCustomerDetails,
}) => {
  const [search, setSearch] = useState("");
  const location = useLocation();
  const [customerID, setCustomerID] = useState("");
  const [matchedRow, setMatchedRow] = useState("");
  const [filter, setFilter] = useState(false);
  const [keyLoading, setKeyLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  // const [customerDetails, setCustomerDetails] = useState({
  //   type: "existing",
  //   firstName: "",
  //   lastName: ""
  // });
  // console.log("step", step);
  // const [rows, setRows] = useState([]);


  // useEffect(() => {

  //   getAllCustomers();

  // }, []);



  // const getAllCustomers = () => {

  //   httpclient
  //     .get(`getCustomers?env=TEST&select=id,customerID,fullName,firstName,lastName,customerType,mobile,email,created_at`)
  //     .then(({ data }) => {
  //       if (data.status === 200) {

  //         setRows(data.records.data);

  //         // Set the customer data to the state

  //       } else {
  //         console.log("Error!");
  //       }
  //     });
  // };

  // const handleChange = (e) => {
  //   setSearch(e.target.value);
  // };

  // const handleSearchFilter = (value) => {
  //   setCustomerDetails(value !== null ? value.fullName : "");
  //   setCustomerID(value !== null ? value.customerID : "");

  // };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);

  };

  useEffect(() => {
    const rows1 = localStorage.getItem("costumer-list");
    // const rows = JSON.parse(rows1);
    if (rows1 != null) {
      setRows(JSON.parse(rows1));
    }
  }, [])

  const { id } = useParams();

  const handleResumeCustomer = () => {
    setCustomerDetails({
      ...customerDetails,
      firstName: "",
      lastName: "",
      customerID: "",
    });
    httpclient
      .get(`searchCustomers?warehouseID=${id}&email=${customerDetails.email}&mobile=${customerDetails.mobile}`
      )
      .then(({ data }) => {
        if (data.status === 200) {
          if (data.records.length === 0) {
            setOpen(true);
            setSnackStatus("warning");
            setSnackMessage(data.message);
          }
          else {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);

          }
          const datas = data.records;
          setRows(datas);
          setCustomerDetails({
            ...customerDetails,
            type: "existing",
            customerID: data.records[0].customerID,
            firstName: data.records[0].firstName,
            lastName: data.records[0].lastName,
            email: data.records[0].email,
            mobile: data.records[0].mobile,

          });


        }
        else {
          console.log("Error!");
        }
      });
  };


  const handleChange = (e) => {

    const { name, value } = e.target;
    setFilter(false);
    setCustomerDetails({
      ...customerDetails,
      [name]: value,
    });
  };

  const handleSearchFilter = (value) => {
    //console.log('new vaue', value);
    setCustomerDetails({
      ...customerDetails,
      fullName: value !== null ? value.fullName : "",
      firstName: value !== null ? value.firstName : "",
      lastName: value !== null ? value.lastName : "",
      email: value !== null ? value.email : "",
      mobile: value !== null ? value.mobile : "",
      customerID: value !== null ? value.customerID : "",
    });
  };

  const handleConfirmCustomer = () => {

    if (customerDetails.firstName && customerDetails.customerID) {
   
      const matchedRow = rows.find(
        (row) =>
          row.firstName === customerDetails.firstName &&
          row.customerID === customerDetails.customerID
      );
      if (matchedRow) {
        setCustomerDetails({
          ...customerDetails,
          firstName: matchedRow.firstName,
          customerID: matchedRow.customerID,
        });
        setFilter(true);
        setTimeout(() => {
          setStep(2);
        }, 500);
      
      }
      else if (customerDetails.customerID !== null || customerDetails.customerID !== "") {
        setCustomerDetails({
          ...customerDetails,
          firstName: customerDetails.firstName,
          customerID: customerDetails.customerID,
        });
        setFilter(true);
        setTimeout(() => {
          setStep(2);
        }, 500);
        
      }
      else {
        setCustomerDetails({
          ...customerDetails,
          firstName: customerDetails.firstName,
          customerID: "",
        });
        setFilter(false);
      }
    }
  };


  const sortedOptions = React.useMemo(() => {
    const inputValue = customerDetails.firstName || customerDetails.lastName || customerDetails.email || customerDetails.mobile || "";

    const matchedInitialLetters = [];
    const remainingOptions = [];
    const seenMobiles = new Set();

    const dedupedRows = rows.filter((option) => {
      if (!option.email || !option.mobile) {
        return false;
      }
      if (seenMobiles.has(option.mobile)) {
        return false;
      }
      seenMobiles.add(option.mobile);
      return true;
    });

    dedupedRows.forEach((option) => {
      const firstName = option.firstName || "";
      const lastName = option.lastName || "";
      const email = option.email || "";
      const mobile = option.mobile || "";

      const isLastNameMatching = lastName !== null && lastName.toLowerCase().startsWith(inputValue.toLowerCase());
      const isEmailMatching = email !== null && email.toLowerCase().startsWith(inputValue.toLowerCase());
      const isMobileMatching = mobile !== null && mobile.toLowerCase().startsWith(inputValue.toLowerCase());

      if (
        (firstName && firstName.toLowerCase().startsWith(inputValue.toLowerCase())) ||
        isLastNameMatching ||
        isEmailMatching ||
        isMobileMatching
      ) {
        matchedInitialLetters.push(option);
      } else {
        remainingOptions.push(option);
      }
    });

    return [...matchedInitialLetters, ...remainingOptions];
  }, [customerDetails.firstName, customerDetails.lastName, customerDetails.email, customerDetails.mobile, rows]);



  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div>
      {/* <Card> */}

      <MainFlex>
        <MainBox>
          <h2>Existing Customers</h2>
          <Box>
            <InputLabel>First Name</InputLabel>

            <Autocomplete
              disablePortal
              inputValue={customerDetails.firstName}
              //options={rows.length > 0 ? rows : []}
              options={sortedOptions}
              getOptionLabel={(option) => option.firstName || null}
              renderOption={(props, option, index) => { return <li {...props} key={option.id}>{option.firstName}</li> }}
              sx={{ width: isMobile ? 300 : 500 }}
              onChange={(event, newValue) => {
                handleSearchFilter(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="firstName"
                  value={customerDetails.firstName || ""}
                  onChange={handleChange}
                />
              )}
            />

            <InputLabel>Last Name</InputLabel>

            <Autocomplete
              disablePortal
              inputValue={customerDetails.lastName === null ? "" : customerDetails.lastName}
              //options={rows.length > 0 ? rows : []}
              options={sortedOptions}
              getOptionLabel={(option) => option.lastName || null}
              renderOption={(props, option, index) => { return <li {...props} key={option.id}>{option.lastName}</li> }}
              // filterOptions={(option) => option}
              sx={{ width: isMobile ? 300 : 500 }}
              onChange={(event, newValue) => {
                handleSearchFilter(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="lastName"
                  value={customerDetails.lastName || ""}
                  onChange={handleChange}
                />
              )}
            />
            <InputLabel>Email</InputLabel>

            <Autocomplete
              disablePortal
              inputValue={customerDetails.email === null ? "" : customerDetails.email}
              //options={rows.length > 0 ? rows : []}
              options={sortedOptions}
              getOptionLabel={(option) => option.email || null}
              renderOption={(props, option, index) => { return <li {...props} key={option.id}>{option.email}</li> }}
              // filterOptions={(option) => option}
              sx={{ width: isMobile ? 300 : 500 }}
              onChange={(event, newValue) => {
                handleSearchFilter(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="email"
                  value={customerDetails.email || ""}
                  onChange={handleChange}
                />
              )}
            />
            <InputLabel>Mobile</InputLabel>

            <Autocomplete
              disablePortal
              inputValue={customerDetails.mobile === null ? "" : customerDetails.mobile}
              //options={rows.length > 0 ? rows : []}
              options={sortedOptions}
              getOptionLabel={(option) => option.mobile || null}
              renderOption={(props, option, index) => { return <li {...props} key={option.id}>{option.mobile}</li> }}
              // filterOptions={(option) => option}
              sx={{ width: isMobile ? 300 : 500 }}
              onChange={(event, newValue) => {
                handleSearchFilter(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="mobile"
                  value={customerDetails.mobile || ""}
                  onChange={handleChange}
                />
              )}
            />

            <Button
              color="primary"
              variant="contained"
              onClick={handleResumeCustomer}
              style={{ marginTop: "12px" }}
              disabled={!customerDetails.email && !customerDetails.mobile}

            >
              Search In another Store{" "}
              <Search fontSize="small" style={{ marginLeft: "5px" }} />
            </Button>

            <Button
              color="primary"
              variant="contained"
              onClick={handleResumeCustomer}
              style={{ marginTop: "12px", marginLeft: "10px" }}
              disabled={!customerDetails.email && !customerDetails.mobile}

            >
              Search In Database{" "}
              <Search fontSize="small" style={{ marginLeft: "5px" }} />
            </Button>

          </Box>
        </MainBox>
      </MainFlex>
      {/* </Card> */}
      <Box mt={3} display="flex" alignItems={"center"} justifyContent="space-between">
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setCustomerDetails({ ...customerDetails, type: "" })}
          style={{ marginRight: "10px" }}
          size="large"
        >
          <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} /> Back
        </Button>

        <Button
          size="large"
          variant="outlined"
          color="secondary"
          // onClick={() => {
          //   setCustomerDetails({ ...customerDetails, type: "new" });
          //   setStep(1);
          // }}
          onClick={() => setStep(1, customerDetails.type = "new")}
          sx={{ margin: "10px" }}

        //disabled={keyLoading1 || keyLoading}
        >
          Move To New Customer
          {/* <ArrowForward fontSize="small" sx={{ marginRight: "5px" }} /> */}
        </Button>


        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirmCustomer}
          size="large"
          //disabled={!filter || ((matchedRow !== null) ? false : true)}
          disabled={!customerDetails.customerID}
        >
          Confirm and Next <ArrowForward fontSize="small" sx={{ marginRight: "5px" }} />
        </Button>
      </Box>
      <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{ width: "100%", position: "relative", top: "40px" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ExistingCustomer;


